import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {ACTION_TYPES} from "../consts";

export class SearchClickHandler extends ActionHandler {
  type = ACTION_TYPES.onSearchClick;

  static injectables = [...ActionHandler.injectables];

  async action(params){
    this.state.appState.isSearchVisible = params.isVisible;

    if(params.isVisible) {
     this.controller.action(ACTION_TYPES.onSearchDisplay, {source: 'search-button'});
    }
  }
}
